// extracted by mini-css-extract-plugin
export default {"label":"VatToggle_label__Y28uu","switch":"VatToggle_switch__IZ2Wz","slider":"VatToggle_slider__X6rJb"};